import { useLang } from "@/lib/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="border-t border-black pt-20 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <p className="font-heading font-black tracking-tighter leading-none text-[13vw] lg:text-[10vw] text-stroke select-none whitespace-nowrap" aria-hidden="true">
          ZTRUST AFRICA
        </p>
        <div className="flex flex-wrap items-center justify-between gap-6 mt-12 border-t border-black pt-8">
          <p className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground">
            {t("footer.rights")}
          </p>
          <a href="mailto:contact@ztrustafrica.com" data-testid="footer-email-link" className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground hover:text-accent transition-colors duration-300">
            contact@ztrustafrica.com
          </a>
        </div>
      </div>
    </footer>
  );
}
